module.exports = __webpack_public_path__ + "static/media/colaboradores.2fd5e500.svg";